export default __webpack_public_path__ + "static/media/map-marker.8163f98b.svg";